import React, { useState, useEffect } from 'react';

const BottomTicker = ({ message = "Thanks for joining the team! We are adding neighborhoods DAILY. If you don't see yours yet, hold your horses, it's on the way!!" }) => {
  const [showTicker, setShowTicker] = useState(true);
  
  useEffect(() => {
    // Hide ticker after 90 seconds
    const hideTimer = setTimeout(() => {
      setShowTicker(false);
    }, 90000); // 90 seconds
    
    // Show ticker again every 30 minutes
    const repeatInterval = setInterval(() => {
      setShowTicker(true);
      // Hide again after 90 seconds
      setTimeout(() => {
        setShowTicker(false);
      }, 90000);
    }, 30 * 60 * 1000); // 30 minutes
    
    return () => {
      clearTimeout(hideTimer);
      clearInterval(repeatInterval);
    };
  }, []);
  
  if (!showTicker) return null;
  
  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-amber-900/95 via-amber-800/95 to-amber-900/95 border-t border-amber-700/50 backdrop-blur-sm overflow-hidden"
      data-testid="bottom-ticker"
    >
      <div className="animate-marquee whitespace-nowrap py-2">
        <span className="mx-8 text-sm text-amber-100 font-medium">
          {message}
        </span>
        <span className="mx-8 text-sm text-amber-100 font-medium">
          {message}
        </span>
        <span className="mx-8 text-sm text-amber-100 font-medium">
          {message}
        </span>
      </div>
    </div>
  );
};

export default BottomTicker;
